<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <div class="row" v-if="order">
        <div class="col-lg-8">
          <div class="card no-shadow">
            <div class="card-body" style="color: black !important;">
              <div class="invoice-title">
                <span class="float-end font-size-9"></span>
                <div class="mb-4">
                  <img
                      src="@/assets/images/logo-dark-url.png"
                      alt="logo"
                      height="80"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-4" >
                  <address class="font-size-10" style="margin-left: 4px;margin-top: 4px;">
                    <b>Spitzen Leichtathletik Luzern</b><br />Postfach, 6002 Luzern<br />
                    <u>ticket@spitzenleichtathletik.ch</u><br />
                    <u>www.spitzenleichtathletik.ch</u><br />
                  </address>
                </div>
                <div class="col-6" style="padding-left: 160px;">
                  <address>
                    <span class="absender">Spitzen Leichtathletik Luzern, Postfach, 6002 Luzern</span><br />
                    {{order.company}}<br />
                    {{order.gender | formatGender }} {{order.firstname}} {{order.name}}<br />
                    {{order.address}}<br />
                    <template v-if="order.address2">{{order.address2}}<br /></template>
                    {{order.zip}} {{order.city}}
                  </address>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-1 p2">
                  <p class="mt-4 mb-4">Luzern, {{ today | formatDate }}</p>
                  <h5 style="color: black;">Spitzen Leichtathletik Luzern, 16. Juli 2026 - Ticketing</h5>
                  <p class="mt-4">{{ ansprache }}</p>
                  <p>Vielen Dank für Ihre Anmeldung zum <b>Spitzen Leichtathletik Meeting vom 16. Juli 2026</b>. Wir freuen uns, Sie am diesjährigen Meeting begrüssen zu dürfen. Gerne senden wir Ihnen anbei die entsprechenden Eintrittskarten<template v-if="this.order.parkingCount === 1"> sowie eine Parkkarte für das Parking Sportgebäude Allmend (Parkhaus)</template>.
                  <template v-if="this.order.parkingCount > 1"> sowie Parkkarten für das Parking Sportgebäude Allmend (Parkhaus)</template>.</p>
                  <p><template v-if="this.order.insideSpecial > 0"> Der farbige Armbändel ermöglicht einen exklusiven Einblick hinter die Kulissen des Meetings (Inside-Special-Führung).</template>
                  <template v-if="this.order.gallery > 0"> Der farbige Armbändel ermöglicht während dem Meeting den exklusiven Zugang zur VIP-Galerie (hinterste Reihe der Tribüne).</template>
                  <template v-if="this.order.parkingCountMesse > 0"> Mit der SLL-Parkkarte haben Sie Zugang zum OK/Presse-Parkplatz hinter den Messehallen. Die Zufahrt ist über die Einfahrt bei der Halle 1 möglich (Ausgeschildert: Anlieferung Messe).</template>
                  </p>

                  <p>Unter <u>spitzenleichtathletik.ch</u> finden Sie einen Situationsplan der Allmend Luzern sowie Informationen rund um die Veranstaltung.</p>

                  <p><template v-if="this.order.before > 0">Mit dem VIP-Ticket kann ab 17.30 Uhr in der FCL Business Lounge ein Stehimbiss genossen werden.</template> Das internationale Hauptprogramm startet kurz vor 19.00 Uhr (Zeitplan inkl. Vorprogramm auf unserer Webseite).</p>

                    <p class="mt-4">Wir wünschen Ihnen viel Vergnügen am Event und sportliche Grüsse</p>
                    <p>OK Spitzen Leichtathletik Luzern </p>
                </div>
              </div>
              <div class=" mt-3 anhang">
                <b>Anlagen</b>
                <ul class="mb-0">
                  <li v-if="this.order.parkingCount === 1">1 Parkkarte</li>
                  <li v-if="this.order.parkingCount > 1">{{ this.order.parkingCount }} Parkkarten</li>
                  <li v-if="this.order.parkingCountMesse > 0">{{ this.order.parkingCountMesse }} Parkkarte Messe</li>
                  <li v-if="this.order.before > 0"><template v-if="this.order.before !== this.order.tickets.length">{{ this.order.tickets.length }} Tickets, davon </template>{{ this.order.before }} VIP-Packages</li>
                  <li v-if="this.order.tickets">Tickets:</li>
                </ul>
                <div class="row mt-0 mb-0" style="margin-left: 20px;" v-if="sortedTickets">

                  <template v-for="s in sortedTickets">
                    <div class="col-4 mb-3" :key="s">
                      <div  class="d-block" :key="t.id" v-for="t in s">{{t.seat}}</div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="d-print-none">
                <div class="float-end">
                  <a
                      href="javascript:window.print()"
                      class="btn btn-success waves-effect waves-light me-1"
                  ><i class="fa fa-print"></i
                  > Drucken</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 d-print-none">
          <div class="card">
            <div class="card-body">
              <div class="mb-3" v-html="formattedAddress"></div>
              <div class="mb-3">
                Parkkarten: {{ order.parkingCount }}
              </div>

              <b-button @click="shippedOrder"
                        class="btn btn-danger w-md waves-effect waves-light"
              >Versendet</b-button
              > <b-button @click="editOrder"
                  class="btn btn-warning w-md waves-effect waves-light"
              >Edit</b-button
              >
            </div>
          </div>
        </div>
      </div>
  </Layout>
</template>

<script>
import Repository from "@/repositories/RepositoryFactory";
const OrderRepository = Repository.get("orders");

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
/**
 * Ticket Orders Component
 */
export default {
  page: {
    title: "Ticket Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  props: ['id'],
  data() {
    return {
      title: "Ticket Order",
      items: [
        {
          text: "Ticket Orders",
          href: "/orders",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      order: null,

    };
  },
  computed: {
    today(){
      return new Date();
    },
    sortedTickets(){
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const arr = this.order.tickets.sort( this.compareTickets );
      const chunk = 18;
      var arrParts = [];
      var arrIdx = 0;
      for (let i=0,j=arr.length; i<j; i+=chunk) {
        arrParts[arrIdx] = arr.slice(i,i+chunk);
        arrIdx++
      }
      this.$log.debug(arrParts)
      return arrParts;
    },
    ansprache(){
      if(this.order.gender === "HERR"){
        return "Sehr geehrter Herr "+(this.order.firstname ? this.order.firstname : "")+" "+(this.order.name ? this.order.name : "");
      }
      if(this.order.gender === "HERR"){
        return "Sehr geehrte Frau "+(this.order.firstname ? this.order.firstname : "")+" "+(this.order.name ? this.order.name : "");
      }
      return "Sehr geehrte Damen und Herren"
    },
    formattedAddress(){

      let addr = (this.order.company ? this.order.company+"<br />":"");
      addr += (this.order.gender ? this.order.gender === "HERR" ? "Herrn " : this.order.gender === "FRAU"? "Frau ": "":"")+(this.order.firstname ? this.order.firstname+" ":"")+(this.order.name ? this.order.name+" ":"")+"<br />";
      addr += (this.order.address ? this.order.address+"<br />":"");
      addr += (this.order.address2 ? this.order.address2+"<br />":"");
      addr += (this.order.zip ? this.order.zip+" ":"")+(this.order.city ? this.order.city+" ":"");

      return addr;
    },
  },
  created() {
    this.getOrder();
  },
  mounted() {

  },
  methods: {
    compareTickets( a, b ) {
      if ( a.seat < b.seat ){
        return -1;
      }
      if ( a.seat > b.seat ){
        return 1;
      }
      return 0;
    },
    shippedOrder(){
      OrderRepository.shipTickets(this.id).then(() => {
        this.$router.push({ name: "orders"});
      }).catch((err)=>{
        Swal.fire("Error", err, "error");
      });
    },
    editOrder(){
      this.$router.push({ name: "orders-id", params: {id: this.order.id}});
    },
    getOrder: async function() {
      const { data } = await OrderRepository.get(this.id);
      this.order = data;
    },
  },
};
</script>
<style lang="scss" scoped>
.anhang {
  font-size: 10px !important;
}
.card.no-shadow{
  box-shadow: none;
}
.absender {
  white-space: nowrap;
  font-size: 9px;
  font-weight: bold;
  text-decoration: underline;
  width: 150px;
}
</style>